import RulesList from "../components/templates/RulesList"

export default function RulesListPage() {
  return <RulesList />
}